import { BaseSection, InputContainer } from 'components/layout/Section/BaseSection';
import { NsKey } from 'enums/NsKey';
import { InputFactory } from 'factories/InputFactory';
import { AddressFormFieldNames } from 'shared/enums/addressFormFieldNames';
import { useDynamicTranslation } from 'hooks/useDynamicTranslation';
import { useCallback } from 'react';
import { tenantGuarantorInputsConfig } from '../../form/tenantGuarantorInputsConfig';
import { TenantFormFieldNames } from '../../types/tenantFormFieldNames';

export const TenantGuarantorLayout: React.FC = () => {
  const { t } = useDynamicTranslation([NsKey.RealEstate, NsKey.Common, NsKey.ActorForm]);

  const renderField = useCallback((fieldName: any) => {
    return (
      <InputFactory config={tenantGuarantorInputsConfig} fieldName={fieldName} />
    );
  }, []);

  return <div className="font-lato flex flex-col gap-4">
    <BaseSection title={t('TENANT.SECTIONS.GUARANTOR_INFOS')}>
      <div className='pt-2'>
        <InputContainer>
          <div className="w-full col-span-6 flex gap-4">
            <div className="w-32">
              {renderField(TenantFormFieldNames.Civility)}
            </div>
            <div className="flex-grow">
              {renderField(TenantFormFieldNames.LastName)}
            </div>
          </div>
          <div className="col-span-3">
            {renderField(TenantFormFieldNames.FirstName)}
          </div>
          <div className="col-span-3">
            {renderField(TenantFormFieldNames.BirthDate)}
          </div>
          <div className="col-span-3">
            {renderField(TenantFormFieldNames.Phone)}
          </div>
          <div className="col-span-3">
            {renderField(TenantFormFieldNames.Email)}
          </div>
          <div className="col-span-3">
            {renderField(TenantFormFieldNames.ProfessionalSituation)}
          </div>
        </InputContainer>
      </div>
    </BaseSection>
    <BaseSection title={t('ACTOR_FORM.LABELS.COORDINATE_SECTION')}>
      <div className="grid grid-cols-6 gap-4">
        <div className="col-span-3">
          {renderField(AddressFormFieldNames.Address)}
        </div>
        <div className="col-span-3">
          {renderField(AddressFormFieldNames.AdditionalAddress)}
        </div>
        <div className="col-span-3">
          {renderField(AddressFormFieldNames.PostalCode)}
        </div>
        <div className="col-span-3">
          {renderField(AddressFormFieldNames.City)}
        </div>
        <div className="col-span-3">
          {renderField(AddressFormFieldNames.Country)}
        </div>
      </div>
    </BaseSection>
    <BaseSection title={t('TENANT.SECTIONS.GUARANTOR_INCOMES_SECTION')}>
      <div className='rounded-xl p-4 border shadow bg-white'>
        {renderField(TenantFormFieldNames.Incomes)}
      </div>
    </BaseSection>
  </div>
};
